import { render, staticRenderFns } from "./detail_plateform.vue?vue&type=template&id=68d887d6&scoped=true&"
import script from "./detail_plateform.vue?vue&type=script&lang=js&"
export * from "./detail_plateform.vue?vue&type=script&lang=js&"
import style0 from "./detail_plateform.vue?vue&type=style&index=0&id=68d887d6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d887d6",
  null
  
)

export default component.exports